export default __webpack_public_path__ + "static/media/burningvigor.8d5ba467.png";